/**
 * Метод перестановки элементов
 * @param arr
 * @param lIndex
 * @param rIndex
 */
export const arrayMoveImmutable = <T = string>(
  arr: T[],
  lIndex: number,
  rIndex: number
): T[] => {
  if (lIndex === rIndex || lIndex > arr.length - 1 || rIndex > arr.length - 1) {
    return arr;
  }

  const newArr = [...arr];

  const l = newArr[lIndex];

  const r = newArr[rIndex];

  newArr[lIndex] = r;
  newArr[rIndex] = l;

  return newArr;
};

export const range = (i: number) => Array.from(Array(i).keys());
